import { render, staticRenderFns } from "./OpenInvoice.vue?vue&type=template&id=18d64f82&scoped=true&"
import script from "./OpenInvoice.vue?vue&type=script&lang=js&"
export * from "./OpenInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OpenInvoice.vue?vue&type=style&index=0&id=18d64f82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d64f82",
  null
  
)

export default component.exports